<hr />

<small>
  <div [innerHTML]="htmlStandardText"></div>
</small>
